import React from "react"
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer"

import PdfHeader from "./PdfHeader"
import PdfTable from "./PdfTable"
import PdfTotals from "./PdfTotals"
// import PdfAction from "./PdfAction/index"

// Create styles
const styles = StyleSheet.create({
  page: {
    fontSize: "10px",
    padding: "40px",
    lineHeight: "1.2px",
    display: "flex",
    flexDirection: "column",
  },
  headingSection: {
    marginBottom: 10,
    padding: 10,
    display: "flex",
  },
  tableSection: {
    padding: 5,
  },
  actionsSection: {
    marginBottom: 10,
    marginTop: 10,
    border: "1px solid #9A9A9A",
    borderRadius: "4px",
    padding: 10,
    minHeight: 100,
  },
  labels: {
    backgroundColor: "#FFFFFF",
    lineHeight: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
  },
  expenseRow: {
    margin: "1px 0 0 20px",
    backgroundColor: "#FFF0EF",
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    borderRadius: "4px",
    padding: "5px 10px",
  },
  expenseName: {
    width: "60%",
  },
  expenseNumberItem: {
    width: "20%",
    textAlign: "right",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
})

// Create Document Component
const ClientPdf = ({ data = {}, client }) => {


  const type = data && data.type
  const hasLineDiscounts = data && data.hasLineDiscounts
  const passedAmounts = (data && data.passedAmounts) || {}
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headingSection}>
          <PdfHeader data={data} type={type} />
        </View>
        <View style={styles.labels}>
          <Text style={[styles.expenseName, { marginLeft: "10px" }]}>ITEM</Text>

          <Text style={[styles.expenseNumberItem, { marginRight: "20px" }]}>
            QTY
          </Text>
          <Text style={[styles.expenseNumberItem, { marginRight: "30px" }]}>
            RATE
          </Text>
          {hasLineDiscounts && (
            <Text style={[{ marginRight: "10px" }]}>DISCOUNT($)</Text>
          )}
          <Text style={[styles.expenseNumberItem, { marginRight: "20px" }]}>
            TOTAL
          </Text>
        </View>
        <View style={styles.tableSection}>
          {data &&
            data.users.map((pos, i) => {
              // if type invoice, additional expenses rolled into expenses
              // otherwise just expenses
              const userTotalExpenses =
                type.toLowerCase() === "invoice"
                  ? pos.hasOwnProperty("additional_expenses")
                    ? [...pos.expenses, ...pos.additional_expenses]
                    : pos.expenses
                  : pos.expenses
              return (
                <PdfTable
                  key={i}
                  hasLineDiscounts={hasLineDiscounts}
                  position={{ ...pos, expenses: userTotalExpenses }}
                />
              )
            })}
          {data.users.length === 0 && (
            <View>
              <Text>There are no roles on this {type} currently.</Text>
            </View>
          )}
        </View>
        <View
          wrap={false}
          style={{
            display: "flex",
            flexDirection: "row",
            paddingTop: 20,
            paddingBottom: 20,
            marginLeft: 10,
            marginRight: 10,
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "50%",
              paddingRight: "35px",
            }}
          >
            {data[`${type}_note`] !== null &&
              data[`${type}_note`] !== "" && (
                <View>
                  <Text>NOTE FROM CREW MAMA</Text>
                  <View style={styles.actionsSection}>
                    <Text>{data[`${type}_note`]}</Text>
                  </View>
                </View>
              )}
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "50%",
              paddingLeft: "50px",
            }}
          >
            <PdfTotals data={data} amounts={passedAmounts} type={type} client={client} />


          </View>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
        <View>
          <Text>
            -Payments completed by credit card incur a 3.8% processing fee per transaction.
          </Text>
        </View>
        <View>
          <Text>
            -Estimated expenses including travel, meals, mileage, shipping, hard
            drive, or expenses will be billed as used.
          </Text>
        </View>
        <View>
          <Text>
            -Any additions or deletions of personnel, equipment or shoot days
            should be handled through Crew Mama Rep.
          </Text>
        </View>
        <View>
          <Text>
            -Canceled Bookings are charged: $100.00 72 hours before shoot, 50%
            of day rate 48 -71 hours before shoot, 100% of day rate 24-47 hours
            before shoot
          </Text>
        </View>
      </Page>
    </Document>
  )
}

export default ClientPdf
